var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFunnelFilterImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 42,
    height: 39,
    rx: 3.5,
    stroke: "#0000A0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0472 15.875H24.9597L21.4965 20.2063L18.0472 15.875ZM16.1463 15.6069C17.5426 17.3875 20.121 20.6875 20.121 20.6875V24.8125C20.121 25.1906 20.432 25.5 20.8122 25.5H22.1947C22.5749 25.5 22.886 25.1906 22.886 24.8125V20.6875C22.886 20.6875 25.4574 17.3875 26.8537 15.6069C27.2063 15.1531 26.8814 14.5 26.3076 14.5H16.6924C16.1186 14.5 15.7937 15.1531 16.1463 15.6069Z",
    fill: "#0000A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnelFilterImage);
export default __webpack_public_path__ + "static/media/funnelFilterImage.a8e150242425855076a037fcf6591672.svg";
export { ForwardRef as ReactComponent };